module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.category !== null) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('category-form', {
    attrs: {
      "category": _vm.category
    },
    on: {
      "saved": _vm.reloadCategory
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Products in this category")]), _vm._v(" "), _vm._l((_vm.linkedProducts), function(product) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(product.name) + "\n                ")])], 1)
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', [_vm._v("Add product to category...")])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6790f89c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/categories/CategoryEdit.vue
// module id = 547
// module chunks = 0